
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M11.7 1.7H3.3v16.7h13.3V6.7l-4.9-5zM13.3 15H6.7v-1.7h6.7V15zm0-3.3H6.7V10h6.7v1.7zm-2.5-4.2V2.9l4.6 4.6h-4.6z"}})])
          )
        }
      }
    